import { render, staticRenderFns } from "./VideoFoto.vue?vue&type=template&id=225f9e9a&scoped=true&"
import script from "./VideoFoto.vue?vue&type=script&lang=js&"
export * from "./VideoFoto.vue?vue&type=script&lang=js&"
import style0 from "./VideoFoto.vue?vue&type=style&index=0&id=225f9e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f9e9a",
  null
  
)

export default component.exports